module.exports = __webpack_public_path__ + "static/media/staff.30fa5e54.svg";